<template>
  <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
    <template slot="table-body">
      <print-report-list-component ref="PrintReportListComponent" @afterLoadData="onAfterLoadData"></print-report-list-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PrintReportListComponent from "../components/PrintReportListComponent.vue";

export default {
  components: { SaPageLayout, PrintReportListComponent },
  data() {
    return {
      btnNewVisible: true,
      pathResource: "",
      linkedit: "/printreport",
      showModalLoading: false,
      listKey: 0,
    };
  },
  mounted() {
    let me = this;
    me.loadData();
  },
  methods: {
    loadData() {
      let me = this;
      me.showModalLoading = true;
      me.$refs.PrintReportListComponent.loadData();
    },
    onRefresh() {
      let me = this;
      me.loadData();
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
  },
};
</script>

<style></style>
